import { render, staticRenderFns } from "./OrderGroupList.vue?vue&type=template&id=149f2bff&scoped=true"
import script from "./OrderGroupList.vue?vue&type=script&lang=js"
export * from "./OrderGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149f2bff",
  null
  
)

export default component.exports